module.exports = "<form class=\"som-forms\">\n    <im-double-select\n        ng-if=\"CompanyConfigurationExporterCtrl.options\"\n        options=\"CompanyConfigurationExporterCtrl.options\"\n        selected=\"CompanyConfigurationExporterCtrl.selected\"\n    >\n    </im-double-select>\n\n    <dl class=\"form-element space-top\">\n        <dd>\n            <a\n                class=\"btn-standard\"\n                ng-click=\"CompanyConfigurationExporterCtrl.save()\"\n            >\n                Zapisz\n            </a>\n        </dd>\n    </dl>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/company_configuration/exporter/exporter.html
// module id = 530
// module chunks = 0